
import { computed } from '@nuxtjs/composition-api'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { SIM_CARD_TYPE } from '~/constants/CheckoutFlow'

export default {
  name: 'TlmCheckoutCurrentSimTypeSelector',
  components: { FontAwesomeIcon },
  props: {
    isNumberPorting: {
      type: Boolean,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },
  setup(props, { emit }) {
    const selected = computed({
      get: () => props.value,
      set: (val) => {
        emit('input', val)
        emit('update:simTypeRadioGroup', SIM_CARD_TYPE.E_SIM)
        emit('update:esimOnlyDevice', true)
      }
    })

    return { selected, SIM_CARD_TYPE }
  }
}
